import { useApiQuery } from 'hooks/useApiQuery'

export const useGetRewardItems = () =>
  useApiQuery({
    path: '/admin/rewards',
    method: 'get',
    queryKey: ['admin/rewards'],
    queryArgs: {},
  })
